import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={4} width={32} height={24} rx={4} fill="white" />
    <rect
      x={0.5}
      y={4.5}
      width={31}
      height={23}
      rx={3.5}
      stroke="#161C24"
      strokeOpacity={0.1}
    />
    <path
      d="M10.9451 13.3495L11.8059 11.3107L12.5232 13.3495H10.9451Z"
      fill="#016CC9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 16.4757L10.2996 9H13.3122L14.6034 12.0583V9H18.1899L18.9072 10.835L19.6245 9H23.3544V15.6602H24L20.7722 19.3301L24 23H19.6245L18.6203 21.7767L17.616 23H9.58228V16.4757H7ZM8.57806 15.5243L10.8734 9.95146H12.7384L15.1772 15.5243H13.4557L13.0253 14.7087H10.443L10.0127 15.5243H8.57806ZM15.6076 9.95146V15.5243H16.8987V11.4466L18.3333 15.5243H19.7679L21.2025 11.4466V15.5243H22.4937V9.95146H20.1983L19.0506 13.6214L17.616 9.95146H15.6076ZM10.5865 16.4757V22.0485H15.1772V20.9612H12.0211V19.8738H15.1772V18.6505H12.0211V17.699H15.1772V16.4757H10.5865ZM15.2489 22.0485H17.1857L18.6203 20.4175L20.1266 22.0485H21.9916L19.481 19.3301L21.9916 16.4757H20.1266L18.6203 18.2427L17.1139 16.4757H15.2489L17.7595 19.3301L15.2489 22.0485Z"
      fill="#016CC9"
    />
  </svg>
);
export default SVGComponent;
